import { LogData } from '@zerops/models/project';

export enum TimestampsOptions {
  SHOW = '1',
  HIDE = '0'
}

export enum FormatOptions {
  RAW = 'raw',
  RFC_5424 = 'rfc_5424',
  RFC_3164 = 'rfc_3164',
  JSON = 'json'
}

export interface TrLogUrlParams {
  from?: string;
  till?: string;
  limit?: string | number;
  projectId?: string;
  serviceStackId?: string;
  containerId?: string;
  facility?: any;
  content?: string;
  desc?: '1' | '0';
  minimumSeverity?: string;
  tags?: string;
  showTimestamps?: TimestampsOptions;
  format?: FormatOptions;
}

export interface TrLogParams {
  from?: string;
  till?: string;
  limit?: string | number;
  projectId?: string;
  instanceId?: string;
  serviceStackId?: string;
  containerId?: string;
  source?: 'access-logs' | 'logs';
  content?: string;
  desc?: '1' | '0';
  minimumSeverity?: string;
  period?: string;
  mode: 'tail' | 'absPeriod' | 'relPeriod' | 'range' | 'limit' | 'append' | 'prepend';
  tags?: string;
  showTimestamps?: TimestampsOptions;
  format?: FormatOptions;
}

export interface TrLogOptions {
  live: boolean;
  liveCancellable: boolean;
  liveFollow: boolean;
}

export interface TrLogState {
  data: {
    items: LogData[];
    hasMore: boolean;
  };
  info: {
    tags: string[];
  };
  options: TrLogOptions;
  params: TrLogParams;
  loading: boolean;
  loadingInfo: boolean;
  loadMoreLoading: boolean;
}

export interface GetLogPayload extends TrLogParams {
  key: string;
  projectId: string;
  live?: boolean;
}

export interface OpenLogStreamPayload extends TrLogParams {
  key: string;
  projectId: string;
}

export interface LogRes {
  items: LogData[];
  nextPage: boolean;
}

export interface LogInfoRes {
  tags: string[];
}

export enum Facilities {
  Sixteen = 16,
  Seventeen = 17
}

export enum Severities {
  All = 'ALL',
  Unknown = 'UNKNOWN',
  Emergency = 'Emergency',
  Alert = 'Alert',
  Critical = 'Critical',
  Error = 'Error',
  Warning = 'Warning',
  Notice = 'Notice',
  Informational = 'Informational',
  Debug = 'Debug'
}

export const SEVERITIES = [
  {
    name: 'Emergency',
    value: '0'
  },
  {
    name: 'Alert',
    value: '1'
  },
  {
    name: 'Critical',
    value: '2'
  },
  {
    name: 'Error',
    value: '3'
  },
  {
    name: 'Warning',
    value: '4'
  },
  {
    name: 'Notice',
    value: '5'
  },
  {
    name: 'Informational',
    value: '6'
  },
  {
    name: 'Debug',
    value: '7'
  }
];

export const SEVERITIES_MAP = Object.fromEntries(
  SEVERITIES.map(itm => [itm.value, itm])
);

export const LOG_OPTIONS_KEYS: (keyof TrLogParams)[] = [
  'serviceStackId',
  'from',
  'till',
  'limit',
  'containerId',
  'desc',
  'minimumSeverity',
  'tags'
];
